export const graphMulti = {
    rolesCanShowBannerInfo: ['administrator', 'manager', 'director', 'trainer', 'learner'],
}